import Loading from '../../Components/Loading/Loading';
export default Loading;
